import * as actionTypes from "../../actions/actionTypes";
import {updateObject} from "../../shared/utility";
import UtilService from "../../../helper/service";

export const initialUserMetrics = {
  modLastActivePage: 0,
  asyncLastActivePage: 0,
  reelsLastActivePage: 0,
  iscopyExperience:false,
  path: 0, // 1 - preOrdered, 2 - liveExperience
  content: '', // ENTERTAINMENT
  item: '', // TV
  measureWay: 0,
  compatible: -1,
  save_setting: false,

  // live-experience (Moderated)
  moderatedInviteWay: '', //link, calendar
  moderatedName: '',

  // modStartDateTime: UtilService.getRoundedUpDateTime(new Date()),
  // modEndDateTime: UtilService.getXHoursAboveDateTime(UtilService.getRoundedUpDateTime(new Date()), 1),
  modStartDateTime: UtilService.getStartDateTime(),
  modEndDateTime: UtilService.getEndDateTime(UtilService.getStartDateTime()),
  moderatedCalendarInviteStep: 1,
  moderatedAgendaSchedules: [],
  moderatedInviteLink: '',
  moderatedCompleted: false,

  // pre-recorded (Async)
  isLink: true,
  sessionCode: '',
  streamType: '',
  asyncVideoUrl: '',
  asyncFileName: '',
  asyncFileType: 'VIDEO',
  asyncFile: null,
  advanceFeature: false,
  linkUploaded: false, // for Youtube or Vimeo link
  fileUploaded: false, // for uploading from local computer
  stimulusList: [],
  asyncExperienceName: '',

  asyncStartDateTime: UtilService.getStartDateTime(),
  asyncEndDateTime: UtilService.getXHoursAboveDateTime(UtilService.getStartDateTime(), 24),
  asyncCSVName: '',
  asyncParticipants: [],
  asyncCompleted: false,
  surveyLink:'',
  enable_controls:false,
  enable_watermark:false,
  myOwn: false,
  trialFirstStep: true,
  otherSubmitted: false,
  braintrust: null,
  copyExperience: null,
  updateBraintrustMetrics: false,
  startNow: false,
  nowDateTime: new Date(),
  addParticipantList: false,
  listsParticipants: [],
  selectedHubs: [],
  disable_fingerpulse: false,
  using_hub_connectivity: false,
  sessions: [],
  createReel: false,
  lastAsyncFileName: '',
  lastAsyncFile: null,
  lastAsyncVideoUrl: '',
  lastAsyncExperienceName: '',
  lastStreamType: '',
  lastIsLink: true,
  lastReelSessionCode: '',
  reelCanceled: false,
  reelVDOSessionCods: []
};

const initialState = {
  userMetrics: {...initialUserMetrics},
  page: 0,
  prevPage: -1,
  is_loaded: false,
  lastValue: null,
  initialLoad: false,
  asyncThumbnailImg: null,
  globalCompatible: -1,
  globalSaveSetting: false,
  hubLists: [],
  loading: false
};

const reducer = (state = {...initialState}, action: any) => {
  switch (action.type) {
    
    case actionTypes.CREATOR_EXPERIENCE_BUILDER_GET_SUCCESS:
      return updateObject(state, {
        userMetrics: action.payload,
        is_loaded: true,
      });
    
    case actionTypes.CREATOR_REELS_BUILDER_NEXT_PAGE:
      const reelspageData: {
        prevPage?: number;
        page?: number;
      } = {};
      reelspageData.prevPage=state.page;
      reelspageData.page=action.payload;
      return updateObject(state,reelspageData);

    case actionTypes.CREATOR_EXPERIENCE_BUILDER_NEXT_PAGE:
      const pageData:{
        prevPage?:number;
        page?: number;
      }={};
      pageData.prevPage=state.page;
      pageData.page=action.payload;
      return updateObject(state,pageData);

    case actionTypes.UPDATE_USER_METRICS:
      const newMetrics: any = state.userMetrics;
      newMetrics[action.payload.title] = action.payload.value;
      return updateObject(state, {
        userMetrics: newMetrics,
        lastValue: action.payload
      });

    case actionTypes.EMPTY_USER_METRICS:
      return updateObject(state, {
        userMetrics: {...initialUserMetrics},
      });

    case actionTypes.USER_ATTRIBUTE_GET_SUCCESS:

      const data = action.payload.find((item: any) => item.metrics_value === 'CREATOR_EXPERIENCE_BUILDER');

      if (data) {
        if (data.temporary_value) {
          data.temporary_value.asyncStartDateTime = new Date(data.temporary_value.asyncStartDateTime);
          data.temporary_value.asyncEndDateTime = new Date(data.temporary_value.asyncEndDateTime);
          data.temporary_value.modStartDateTime = new Date(data.temporary_value.modStartDateTime);
          data.temporary_value.modEndDateTime = new Date(data.temporary_value.modEndDateTime);
        }
        return updateObject(state, {
          userMetrics: {...data.temporary_value},
          initialLoad: true,
        });
      } else {
        return updateObject(state, {
          initialLoad: true,
        });
      }
    
    case actionTypes.USER_ATTRIBUTE_UPDATE_SUCCESS:
      return updateObject(state, {
        // userMetrics: {...initialUserMetrics},
      });

    case actionTypes.EXPERIENCE_CATEGORIES_SUCCESS:
      return updateObject(state, {
        categories: action.payload,
      });

    case actionTypes.CHANGE_ASYNC_THUMBNAIL_IMG:
      return updateObject(state, {
        asyncThumbnailImg: action.payload,
      });

    case actionTypes.GET_USERMETRICVALUE_SUCCESS:
      const jsonValue = action.payload['temporary_value'];
      return updateObject(state, {
        globalCompatible: jsonValue['compatible'],
        globalSaveSetting: jsonValue['save_setting']
      });

    case actionTypes.GET_HUBS_SUCCESS:
      return updateObject(state, {
        hubLists: action.payload
      });

    case actionTypes.EXPERIENCE_BUILDER_LOADING:
      return updateObject(state, {
        loading: action.payload
      });

    default:
      return state;
  }
};

export default reducer;
